import { createFileRoute } from "@tanstack/react-router";
import { OneBuildingCard } from "@/components/app/workspace/one-building-card";
import { PageHeader } from "@/components/app/shell/page-header";
import { useFacility } from "@/lib/facility/facility";
import { guardRoute } from "@/lib/policy/route-guard";
import { FacilityRecord } from "./facilities/-components/facility-record";

export const Route = createFileRoute("/_authenticated/_administration/settings/facility")({
  beforeLoad: ({ context }) => guardRoute(context.me, "facility-profile"),
  component: FacilityProfilePage,
});

/** The building in view's own record and settings; the switcher at the top changes which. */
function FacilityProfilePage() {
  const { facilityId } = useFacility();
  if (facilityId === "all") {
    return (
      <>
        <PageHeader
          title="Facility profile"
          meta="Each building keeps its own details, sign-out rules, eMAR start and team."
        />
        <OneBuildingCard prompt="Choose a facility to see and change its profile." />
      </>
    );
  }
  return <FacilityRecord key={facilityId} facilityId={facilityId} />;
}
